import { render, staticRenderFns } from "./ArticlesTeaser.vue?vue&type=template&id=a9a93806&"
import script from "./ArticlesTeaser.vue?vue&type=script&lang=js&"
export * from "./ArticlesTeaser.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesTeaser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports